import React, { useEffect, useState, useRef } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';

import DataTableList from '../../components/DataTable/DataTableList';
import { getRecentActivityList, reportListApi, getReportCounts, suspendReportApi, transactionListApi } from '../../api/usersApi';
import { formatTimeAgo } from '../../utils/formattedDate';
import { PageTabs } from '../../components/PageTabs';
import { useStaticDataStore } from '../../stores/staticData';
import { PAYMENT_PLAN } from '../../constants/common';
import EditReport from '../../components/Reports/EditReport';
import EditTransaction from '../../components/Transaction/EditTransaction';
import AllActivities from './AllActivities ';
import SignUp from './SignUp';
import DeleteAccount from './DeleteAccount';
import NewMatch from './NewMatch';
import Payment from './Payment';
import NoResults from '../../components/Noresults';
import Notification from '../../components/Notification';

import avatar from '../../assets/images/Avatar.png'
import report from "../../assets/images/report.png"


const DashboardBoxes = () => {
    const location = useLocation();
    const debounceRef = useRef(null);
    const userEditRef = useRef();
    const transactionEditRef = useRef();

    const { data: staticData } = useStaticDataStore();

    let reportReason = [];
    if (staticData?.reportForFounders?.length) {
        reportReason = staticData?.reportForFounders;
    }
    const userPlan = PAYMENT_PLAN;

    const [columnWidths, setColumnWidths] = useState([]);
    const [columnWidthsForPayment, setColumnWidthForPayment] = useState([]);
    const [activePage, setActivePage] = useState("All");
    const [ProfileTabs, setProfileTabs] = useState([
        { name: 'All' },
        { name: 'Sign up' },
        { name: 'Account Deleted' },
        { name: 'New Match' },
        { name: 'Payments' },
    ]);
    const [recentActivityList, setRecentActivityList] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [isLoadingDataReport, setIsLoadingDataReport] = useState(true);
    const [isLoadingDataPayment, setIsLoadingDataPayment] = useState(true);
    const [reportList, setReportList] = useState([]);
    const [isEditReport, setEditReport] = useState(false)
    const [selectedReport, setSelectedReport] = useState({})
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [isSuspendLoading, setIsSuspendLoading] = useState(false);
    const [isIgnoreLoading, setIsIgnoreLoading] = useState(false);
    const [transactionList, setTransactionList] = useState([]);
    const [isEditTransaction, setEditTransaction] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState({});

    useEffect(() => {
        if (reportList?.length > 0 || transactionList?.length > 0) {
            calculateColumnWidths().then(() => {
                setTimeout(() => {
                    setIsLoadingDataReport(false);
                    setIsLoadingDataPayment(false);
                }, 1000);
            });
            calculateColumnWidths();
        }
    }, [reportList, transactionList]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userEditRef?.current && !userEditRef?.current.contains(event.target)) {
                setEditReport(false);
            }
            if (transactionEditRef?.current && !transactionEditRef?.current.contains(event.target)) {
                setEditTransaction(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setIsLoading(true)
        setIsLoadingData(true);
        setIsLoadingDataReport(true)
        setIsLoadingDataPayment(true)
        if (debounceRef?.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            fetchRecentActivity();
            fetchOpenReportList();
            fetchTransaction();
        }, 1500);

        return () => clearTimeout(debounceRef.current);
    }, [])

    const matchCreatedActivities = recentActivityList
        ?.filter(item => item?.activityType === 'MATCH_CREATED');

    const DeletedAccountActivities = recentActivityList
        ?.filter(item => item?.activityType === 'ACCOUNT_DELETED');

    const SignupedActivities = recentActivityList
        ?.filter(item => item?.activityType === 'SIGNUP_COMPLETED');

    const PaymentCompletedActivities = recentActivityList
        ?.filter(item => item?.activityType === 'PAYMENT_COMPLETED');

    const recentActivityApi = async () => {
        const data = await getRecentActivityList();
        return data;
    }

    const fetchRecentActivity = async () => {
        setIsLoadingData(false);
        try {
            setIsLoadingData(true);
            const res = await recentActivityApi();
            if (res?.length > 0) {
                setRecentActivityList(res)
                setIsLoadingData(false);
            } else {
                setIsLoadingData(false)
            }
        } catch (error) {
            console.log(error)
            setIsLoadingData(false);
        }
    }

    const fetchReportList = async (status) => {
        const data = await reportListApi({
            status,
            page: 1,
        }, setIsLoadingDataReport, true);
        return data;
    }

    const fetchOpenReportList = async () => {
        setIsLoading(false)
        try {
            setIsLoading(true)
            setIsLoadingDataReport(true)
            const data = await fetchReportList("OPEN");
            if (data) {
                setReportList(data?.list);
                setIsLoading(false)
            } else {
                setIsLoading(false)
                setIsLoadingDataReport(false)
            }
        } catch (error) {
            console.error(error);
            setIsLoading(false)
            setIsLoadingDataReport(false)
        }
    };

    const actionReport = async (reportId, status) => {
        try {
            await suspendReportApi({
                reportId,
                status,
            });
            return true;
        } catch (error) {
            console.error('API error:', error.response?.data || error.message);
            return false;
        }
    };

    const handleIgnoreUser = async (editSliderData) => {
        setIsIgnoreLoading(false);
        setShowNotification(false);
        try {
            setIsIgnoreLoading(true)
            const success = await actionReport(editSliderData?.id, "IGNORED");
            if (success) {
                const data = await fetchReportList("OPEN")
                if (data) {
                    setReportList(data?.list);
                    setShowNotification(true);
                    setNotificationMessage('The report has been successfully ignored & closed.' || "");
                    setTimeout(() => {
                        setShowNotification(false);
                    }, 8000);
                    setIsIgnoreLoading(false);
                    setEditReport(false);
                }
                return true
            } else {
                setIsIgnoreLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsIgnoreLoading(false);
        }
    }

    const handleSuspendUser = async (editSliderData) => {
        setIsSuspendLoading(false);
        setShowNotification(false);
        try {
            setIsSuspendLoading(true)
            const success = await actionReport(editSliderData?.id, "SUSPENDED");
            if (success) {
                const data = await fetchReportList("OPEN")
                if (data) {
                    setIsLoadingData(false);
                    setReportList(data?.list);
                    setShowNotification(true);
                    setNotificationMessage(`${editSliderData?.reportedName || ""} was suspended and the report has been successfully closed.` || "");
                    setTimeout(() => {
                        setShowNotification(false);
                    }, 8000);
                    setIsSuspendLoading(false);
                    setEditReport(false);
                }
                return true
            } else {
                setIsSuspendLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsSuspendLoading(false);
        }
    }

    const transactionApi = async () => {
        const data = await transactionListApi({
            page: 1,
            limit: 10,
            status: "failed",
        }, setIsLoadingDataPayment,
            true
        );
        return data;
    }

    const fetchTransaction = async () => {
        setIsLoading(false);
        try {
            setIsLoading(true)
            setIsLoadingDataPayment(true)
            const data = await transactionApi()
            if (data?.list?.length <= 0) {
                setIsLoadingDataPayment(false)
            }
            setTransactionList(data?.list);
            setIsLoading(false);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            setIsLoadingDataPayment(false)
        }
    };

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = reportList?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    maxContentLength = Math?.max(dataValue?.length, title?.length);
                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            const tempWidthsPayment = transactionList?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    maxContentLength = Math?.max(dataValue?.length, title?.length);
                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined || tempWidthsPayment !== undefined) {
                const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {

                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                const widthMapPayment = Object?.keys(tempWidthsPayment)?.reduce((acc, key) => {

                    acc[key] = `${tempWidthsPayment[key] * 10 + 40}px`;
                    return acc;
                }, {});

                setColumnWidths(widthMap);
                setColumnWidthForPayment(widthMapPayment);
            }
            resolve(); // Resolve the promise once widths are set
        });

    };

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666',
                letterSpacing: '-0.28px'
            },
        },
    };

    const columns = [
        {
            name: 'Reported',
            selector: (row) => row?.reportedName,
            cell: (row) => (
                <div className="report-col reported" onClick={() => { setEditReport(true); setSelectedReport(row); }}>
                    <img className="recent-reported" src={row?.reportedProfileImg || avatar} alt="avatar" />
                    <span className="recent-reported">{row?.reportedName}</span>
                </div>
            ),
            minWidth: columnWidths['reportedName'] && (parseInt(columnWidths['reportedName']) + 50 > 300) ? '300px' : `${parseInt(columnWidths['reportedName']) + 60}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "12px", paddingBottom: "12px", fontWeight: 500, fontSize: 14, lineHeight: '24px', color: '#05171A' },
        },
        {
            name: 'Reason',
            selector: (row) => row?.reasons,
            cell: (row) => {
                var reasons = row?.reasons?.slice(0, 1);
                var reasonFull = row?.reasons?.slice(1);
                const getReasonValue = (itemKey) => {
                    const found = reportReason?.find(rsn => rsn?.key === itemKey);
                    return found ? found?.value : itemKey;
                };
                return (
                    <div className='industriesCategory'>
                        <div>
                            {reasons?.map((item, index) => (
                                <span key={index}>{getReasonValue(item)}</span>
                            ))}
                            {row?.reasons?.length > 1 && (
                                <div className="industriesList">
                                    <span>+{row?.reasons?.length - 1}</span>
                                    <div className="industriesTooltip">
                                        {reasonFull?.map((item, idx) => (
                                            <p key={idx}>{getReasonValue(item)}</p>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )
            },
            width: columnWidths['reasons'] && `${parseInt(columnWidths['reasons']) - 250}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "12px", paddingBottom: "12px" },
        },
        {
            name: '',
            selector: (row) => row?.reason,
            cell: (row) => (
                <div className="report-col reason" onClick={() => { setEditReport(true); setSelectedReport(row); }}>
                    <div className="info-btn">More Info</div>
                </div>
            ),
            width: '100px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "12px", paddingBottom: "12px", },
        },

    ]

    const paymentColumns = [
        {
            name: 'User',
            selector: (row) => row?.userName,
            cell: (row) => (
                <div className="report-col reported" onClick={() => { setEditTransaction(true); setSelectedTransaction(row) }}>
                    <img className="recent-reported" src={row?.userPic || avatar} alt="avatar" />
                    <span className="recent-reported">{row?.userName}</span>
                </div>
            ),
            minWidth: columnWidthsForPayment['userName'] && (parseInt(columnWidthsForPayment['userName']) + 50 > 300) ? '300px' : `${parseInt(columnWidthsForPayment['userName']) + 30}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "12px", paddingBottom: "12px", fontWeight: 500, fontSize: 14, lineHeight: '24px', color: '#05171A' },
        },
        {
            name: 'Subscription',
            selector: (row) => row?.plan,
            cell: (row) => {
                const matched = userPlan?.find((plan) => plan?.key === row?.plan);
                return (
                    row?.plan?.trim() ? (
                        <div className="report-col reason">
                            <span className='transaction-plan'>{matched?.value}</span>
                        </div>
                    ) : null
                )
            },
            width: columnWidthsForPayment['plan'] && `${parseInt(columnWidthsForPayment['plan'])}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "12px", paddingBottom: "12px" },
        },
        {
            name: '',
            cell: (row) => (
                <div className="report-col reason" onClick={() => { setEditTransaction(true); setSelectedTransaction(row) }}>
                    <div className="info-btn">More Info</div>
                </div>
            ),
            width: '100px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "12px", paddingBottom: "12px", },
        },

    ]

    return (
        <div className='dashboard-boxes'>
            <div className='recent-activity'>
                <div className='recent-activity-header'>
                    <div className='recent-heading'>Recent activity</div>
                    <div className="profile-tabs">
                        <PageTabs tabs={ProfileTabs} activePage={activePage} setActivePage={setActivePage} />
                    </div>
                </div>
                <div
                    className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list' : ''
                        }`}
                >
                    <div className='recent-activity-section'>
                        {activePage === "All" && (
                            recentActivityList?.length > 0 ? (
                                <AllActivities recentActivityList={recentActivityList} />
                            ) : (
                                <NoResults
                                    title="No recent activity yet"
                                    description="Looks like there aren’t any recent activity to show right now. Keep an eye out - new activity is added all the time!"
                                />
                            )
                        )}

                        {activePage === "Sign up" && (
                            SignupedActivities?.length > 0 ? (
                                <SignUp SignupedActivities={SignupedActivities} />
                            ) : (
                                <NoResults
                                    title="No recent signup yet"
                                    description="Looks like there aren’t any signups right now. Keep an eye out - new signups are added all the time!"
                                />
                            )
                        )}

                        {activePage === "Account Deleted" && (
                            DeletedAccountActivities?.length > 0 ? (
                                <DeleteAccount DeletedAccountActivities={DeletedAccountActivities} />
                            ) : (
                                <NoResults
                                    title="No recent delete account yet"
                                    description="Looks like there aren’t any deleted accounts right now. Keep an eye out - new deletes happen all the time!"
                                />
                            )
                        )}

                        {activePage === "New Match" && (
                            matchCreatedActivities?.length > 0 ? (
                                <NewMatch matchCreatedActivities={matchCreatedActivities} />
                            ) : (
                                <NoResults
                                    title="No recent match yet"
                                    description="Looks like there aren’t any matches right now. Keep an eye out - new matches are added all the time!"
                                />
                            )
                        )}

                        {activePage === "Payments" && (
                            PaymentCompletedActivities?.length > 0 ? (
                                <Payment PaymentCompletedActivities={PaymentCompletedActivities} />
                            ) : (
                                <NoResults
                                    title="No recent payment yet"
                                    description="Looks like there aren’t any payments right now. Keep an eye out - new payments are added all the time!"
                                />
                            )
                        )}
                    </div>
                </div>
            </div>
            <div className="table-pagination-wrapper report-list">
                <h3 className="heading">
                    Open reports {reportList?.length > 0 ? `(${reportList.length})` : ''}
                </h3>

                <div
                    className={`pagesTable dataTable-list ${isLoadingDataReport ? 'loading-list' : ''
                        }`}
                >
                    <DataTableList
                        data={reportList}
                        columns={columns}
                        customStyles={customStyles}
                        pagination={false}
                        progressPending={isLoading}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        noDataComponent={
                            <NoResults
                                title='No open reports yet'
                                description="Looks like there aren’t any open reports to show right now. Keep an eye out - we’ll surface anything that needs your attention!" image={report}
                            />}
                    />
                </div>

                {
                    showNotification &&
                    <Notification showNotification={showNotification} notificationMessage={notificationMessage} setShowNotification={setShowNotification} />
                }

                <EditReport
                    setEditReport={setEditReport}
                    ref={userEditRef}
                    selectedReport={selectedReport}
                    isEditReport={isEditReport}
                    handleActionUser={handleSuspendUser}
                    isSuspendLoading={isSuspendLoading}
                    setSelectedReport={setSelectedReport}
                    handleIgnoreUSer={handleIgnoreUser}
                    isIgnoreLoading={isIgnoreLoading}
                />
            </div>
            <div className="table-pagination-wrapper payment-list">
                <div className='payment-list-header'>
                    <h3 className="heading">
                        Failed payments {transactionList?.length > 0 ? `(${transactionList.length})` : ""}
                    </h3>
                </div>
                <div
                    className={`pagesTable dataTable-list ${isLoadingDataPayment ? 'loading-list' : ''
                        }`}
                >
                    <DataTableList
                        data={transactionList}
                        columns={paymentColumns}
                        customStyles={customStyles}
                        pagination={false}
                        progressPending={isLoading}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        noDataComponent={<NoResults title='No failed transactions yet' description="Looks like there aren’t any transactions to show right now. Keep an eye out - new money is joining all the time!" />}

                    />
                </div>
            </div>
            <EditTransaction
                setEditTransaction={setEditTransaction}
                ref={transactionEditRef}
                selectedTransaction={selectedTransaction}
                isEditTransaction={isEditTransaction}
            />
        </div>
    )
}

export default DashboardBoxes